import config from '../config';

/**
 * Listing type helpers for Production Pages (publicData.type === 'page').
 *
 * The value was 'show' until the Aug 2026 rename.
 * Keep going through these helpers rather than comparing to the raw string,
 * so any future rename is a one-line change again.
 */
export const PAGE_TYPE = config.listingTypes.page;

/** True for a Production Page listing. */
export const isPageType = type => type === PAGE_TYPE;

/** Value for `pub_type` search params. */
export const PAGE_TYPE_QUERY = PAGE_TYPE;
